import { render, staticRenderFns } from "./InventoriesCompanyLocationsDialog.vue?vue&type=template&id=5859a302&"
import script from "./InventoriesCompanyLocationsDialog.vue?vue&type=script&lang=ts&"
export * from "./InventoriesCompanyLocationsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports